import React from 'react';
import SupplierFlagsCard from './SupplierFlagsCard';

/**
 * How a supplier is treated once it appears on a sheet.
 *
 * Deliberately has no branch selector: these rules are global, unlike the
 * mapping, which is per branch. That difference is the whole reason the two
 * screens were separated.
 */
const SupplierRulesTab = ({ onToast }) => (
    <div className="sr-stack">
        <section className="sr-card">
            <h2 className="sr-card-title">Supplier rules</h2>
            <p className="sr-hint">
                These apply to every branch. The mapping decides <em>which</em> supplier a part
                comes from; the rules here decide how that supplier is treated once it lands on a
                sheet.
            </p>
        </section>

        <SupplierFlagsCard onToast={onToast} />
    </div>
);

export default SupplierRulesTab;
